import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../images/homes/3d-icon.svg';
import SVG from 'react-inlinesvg';
import I18n from '~/utils/translations';

export default class VirtualTourButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <a className="modal__button modal--media-button" href={this.props.url} target="_blank">
        <div className="home-media-button">
          <SVG className="home-media-button__icon" src={Icon} />
          <p className="home-media-button__text">{I18n.t('pages.homes.virtual_tour.button')}</p>
        </div>
      </a>
    );
  }
}

VirtualTourButton.propTypes = {
  url: PropTypes.string,
};
